import { addWeeks, format, isToday } from "date-fns";
import { get, isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Controls from "../../components/Controls";
import PointHubButton from "../../components/PointHubButton";
import { selectEventAggregate } from "../../modules/eventAggregate/selectors";
import trackingService, { Events } from "../../services/trackingService";
import { getWeekRange } from "../../utils/date";

const formatWeek = (eventAggregate) => {
  if (
    !eventAggregate ||
    !eventAggregate.start_date ||
    !eventAggregate.end_date
  ) {
    return "";
  }

  return `${format(eventAggregate.start_date, "MMM D")} - ${format(
    eventAggregate.end_date,
    "MMM D"
  )}`;
};

const WeekPointSlider = ({ activeDateRange, setActiveDateRange }) => {
  const [dateRange, setDateRange] = useState(getWeekRange(new Date()));
  const eventAggregate = useSelector(
    selectEventAggregate({
      period: dateRange.period,
    })
  );

  const updateDateRange = (offset) => {
    const updatedDateRange = getWeekRange(
      addWeeks(dateRange.startDate, offset)
    );
    setDateRange(updatedDateRange);
    setActiveDateRange(updatedDateRange);
  };

  useEffect(() => {
    if (dateRange.period === activeDateRange.period) {
      setActiveDateRange(dateRange);
    }
  }, [dateRange]);

  return (
    <Controls
      disableNext={isToday(dateRange.endDate)}
      onNavigateNext={() => {
        updateDateRange(1);
        trackingService.trackEvent(Events.POINTS_NEXT, {
          points_period: "week",
        });
      }}
      onNavigatePrevious={() => {
        updateDateRange(-1);
        trackingService.trackEvent(Events.POINTS_PREVIOUS, {
          points_period: "week",
        });
      }}
    >
      <PointHubButton
        active={dateRange === activeDateRange}
        date={formatWeek(eventAggregate)}
        label="Week"
        loading={isEmpty(eventAggregate)}
        onClick={() => {
          setActiveDateRange(dateRange);
          trackingService.trackEvent(Events.POINTS_CLICK, {
            points_period: "week",
          });
        }}
        value={get(eventAggregate, "points")}
      />
    </Controls>
  );
};

WeekPointSlider.propTypes = {
  activeDateRange: PropTypes.shape({
    endDate: PropTypes.instanceOf(Date),
    period: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
  }),
  setActiveDateRange: PropTypes.func,
};

export default WeekPointSlider;
